import React from 'react';
import Button from '@material-ui/core/Button';
import {Box, Container, makeStyles, Typography} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import {useDispatch, useSelector} from "react-redux";
import NoteIcon from '@material-ui/icons/Note';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {TransitionProps} from '@material-ui/core/transitions';
import {acceptDocument, cognitoLogin} from '../../../../store/actions/auth/auth';
import UtilService from "../../../../helper/service";
import roles from "../../../../helper/roles";
import { Loading } from '../../../atoms/commonLoadings';

const useStyles = makeStyles(() => ({
  modalContent: {
    padding: '0!important'
  },
  modalIframe: {
    width: '100%',
    minHeight: 300,
    padding: 0
  },
  downbtn: {
    textTransform: 'none',
    padding: 0
  },
  checkformlabel: {
    fontSize: '14px!important',
    fontWeight: 'bold'
  }
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PrivacyModal({ docData, email, password, sessionData }: { docData: any, email: string, password: string, sessionData: any }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const divRef = React.useRef<HTMLIFrameElement>(null);

  const apolloClient = useSelector((state: any) => state.apolloClient);

  const [open, setOpen] = React.useState(false);
  const [privacyCheck, setSignCheck] = React.useState(false);
  const [currentStep, handleCurrentStep] = React.useState(0);
  const [signDocs, handleSignDocs] = React.useState<any>([]);
  const [loading, handleLoading] = React.useState(false);

  React.useEffect(() => {
    if (!docData) return;
    const { documents } = docData;
    if (documents && documents.length) {
      handleSignDocs(documents);
      setTimeout(() => {
        setOpen(true);
      }, 500);
    }
  }, [docData]);

  // const handleClose = () => {
  //   setOpen(false);
  // };
  
  const checkRedirectPage = (data: any) => {
    let redirectToHome = "user/profile";
    if (data && data.role_access && data.role_access.length > 0) {
      const trail_profile = data.role_access.filter((val: any) => val.access_name === "trial_profile");
      if (trail_profile.length > 0 && trail_profile[0].access_value) {
        redirectToHome = '/subscriber/user/profile';
      }
      const creator_dashboard = data.role_access.filter((val: any) => val.access_name === "creator_dashboard");
      if (creator_dashboard.length > 0 && creator_dashboard[0].access_value) {
        redirectToHome = "/creator/dashboard"
      } else if (UtilService.checkTrialAccess(data, roles['trial']['dashboard'])) {
        redirectToHome = "/subscriber/creator/dashboard"
      } else {
        const participant_dashboard = data.role_access.filter((val: any) => val.access_name === "participant_dashboard")
        if (participant_dashboard.length > 0 && participant_dashboard[0].access_value) {
          redirectToHome = "/participant/dashboard"
        }
      }
      if (data.hasOwnProperty("creator_on_board") && data.creator_on_board) {
        const creator_onboarding = data.role_access.filter((val: any) => val.access_name === "creator_onboarding");
        const trial_onboarding = data.role_access.filter((val: any) => val.access_name === "trial_onboarding");
        if (creator_onboarding.length > 0 && creator_onboarding[0].access_value) {
          redirectToHome = "/creator/onboarding"
        } else if (trial_onboarding.length > 0 && trial_onboarding[0].access_value) {
          redirectToHome = "/subscriber/creator/onboarding";
        }
      }
    }
    return redirectToHome
  }

  const handleStep = () => {
    handleLoading(true);
    if (currentStep === signDocs.length - 1) {
      //last step
      submitDocSign(currentStep);
      if(docData.auth_type === 0){
        submitLogin();
      } else {
        localStorage.setItem('user_data', JSON.stringify(docData))
        localStorage.setItem("user_id", sessionData.user_id?sessionData.user_id:"")
        localStorage.setItem("auth_token", sessionData.auth_token?sessionData.auth_token:"")
        localStorage.setItem("idToken", sessionData.idToken?sessionData.idToken:"")
        window.location.replace(checkRedirectPage(docData))
      }
    } else {
      submitDocSign(currentStep);
      handleCurrentStep(currentStep + 1);
      setSignCheck(false);
      divRef.current?.scrollTo(0, 0);
      handleLoading(false);
    }
  }

  const submitDocSign = (stepIdx: number) => {
    const accpetRequest: any = {
      user_id: docData?docData.user_id:"",
      config_name: signDocs[stepIdx].config_name,
      revision: signDocs[stepIdx].revision,
      schemaname: docData?docData.customer_name:""
    }
    dispatch(acceptDocument(apolloClient.client, accpetRequest));    
  }

  const submitLogin = () => {
    handleLoading(true);
    const requestData = {
      email,
      password
    };
    dispatch(cognitoLogin(apolloClient.client, requestData, docData));
  }

  const handleDocSignCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked;
    setSignCheck(value);
  }

  const descriptionElementRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      {signDocs.length > 0 && (
        <Dialog
          keepMounted
          
          disableEscapeKeyDown
          TransitionComponent={Transition}
          fullWidth={true}
          maxWidth={"md"}
          open={open}
          // onClose={handleClose}
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>{(signDocs[currentStep].display_config ? signDocs[currentStep].display_config : "") 
              // + " " + (signDocs[currentStep].updated_at ? (moment(signDocs[currentStep].updated_at).format("MM/DD/YYYY")) : "")
              }
              </Box>
              <Box>{`${(currentStep + 1)}/${signDocs.length}`}</Box>
            </Box>
          </DialogTitle>
          <DialogContent dividers={true} className={classes.modalContent}>
            <Container maxWidth="md">
              <Box pt={3} pb={2}>
                <Typography variant="subtitle2" gutterBottom>
                  {'This is a legal agreement between you and Immersion.'}
                </Typography>
                <Button
                  className={classes.downbtn}
                  startIcon={<NoteIcon />}
                  color="primary"
                  href={signDocs[currentStep].config_value}>
                  {'Download Doc'}
                </Button>
              </Box>
              {/* <div ref={divRef} style={{ width: "100%", height: '500px', overflowY: 'scroll' }}> */}
              <div style={{ width: "100%", height:  "280px"}}>
                <iframe
                  // className={classes.modalIframe}
                  src={`${signDocs[currentStep].config_value}`}
                  width="100%"
                  height="100%"
                  title="privacy-check" />
              </div>
              <Box pt={1} pb={1}>
                <FormControlLabel
                  classes={{
                    label: classes.checkformlabel
                  }}
                  // disabled={isAllowCheck !== 1}
                  control={
                    <Checkbox
                      // disabled={isAllowCheck !== 1}
                      checked={privacyCheck}
                      onChange={handleDocSignCheck}
                      name="checkedB"
                      color="primary"
                    />
                  }
                  label="By checking this box I confirm that I have read and agree to be bound by the Agreement Above."
                />
              </Box>
            </Container>
          </DialogContent>
          <DialogActions>
            {loading && (
              <Button variant="contained" color="primary" disabled>
                <Loading style={{ width: 35, height: 35 }}/>
              </Button>)}
            {!loading && (
              <Button variant="contained" disabled={!privacyCheck} color="primary" onClick={handleStep}>
                {'Submit'}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
